<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <el-select
      v-model="factorCategoryId"
      size="small"
      style="width:120px;"
      @change="onFactorCategoryIdChanged"
    >
      <el-option
        v-for="factorGroup in factorTree"
        :key="factorGroup.id"
        :value="factorGroup.id"
        :label="factorGroup.name"
      />
    </el-select>

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <key-component-chart-group
        v-for="data in dataList"
        v-if="data.dimensions.length > 0"
        :key="data.id"
        :background-factor-config-map="vocsBackgroundFactorConfigMap"
        :data-config="data"
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../../model/DeviceCategoryConfig'
import {mapGetters} from 'vuex'

import LayoutContent from '../../../../../components/Layout/Content'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import KeyComponentChartGroup from './KeyComponentChartGroup'

export default {
  name: 'StatisticalAnalysisVOCsKeySpecies',
  routeInfo: {
    label: 'VOCs关键物种',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, KeyComponentChartGroup},
  data: () => ({
    query: {
      isFuse: false,
      isAuditFlag: true,
      isMultipleIntegral: true
    },
    unitProp: 'stdUnit',
    factorCategoryId: null,
    filterBackgroundFactors: Object.freeze([]),
    Map: Object.freeze({})
  }),
  computed: {
    ...mapGetters({
      keyComponentIds: 'Factor/keyComponentIds',
      keyComponentIdMap: 'Factor/keyComponentIdMap',
      vocsBackgroundFactorConfigs: 'Factor/vocsBackgroundFactorConfigs',
      vocsBackgroundFactorConfigMap: 'Factor/vocsBackgroundFactorConfigMap'
    }),
    siteDeviceCategoryConfig () {
      let {keyComponentIdMap, vocsBackgroundFactorConfigMap} = this
      return [
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(({factorId}) => keyComponentIdMap[factorId] || vocsBackgroundFactorConfigMap[factorId]))
      ]
    },
    isSetAllFactorIds: () => false,
    factorTree () {
      let {_factorTree} = this

      if (_factorTree.length > 0) {
        return _factorTree[0].children
      } else {
        return []
      }
    },
    currentFactorCategory () {
      let {factorCategoryId} = this
      return this.factorTree.find(factorCategory => factorCategory.id === factorCategoryId)
    }
  },
  methods: {
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false
    //   this.afterSetSiteIds()
    // },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    onFactorCategoryIdChanged () {
      this.query.factorIds = this.currentFactorCategory.children.map(factor => factor.id)
      this.onSearchBtnClick()
    },
    onRelatedChartDblclick () {

    }
  },
  watch: {
    factorTree: {
      immediate: true,
      handler (factorTree) {
        if (factorTree.length > 0) {
          this.factorCategoryId = factorTree[0].id
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/01Key-Species/index.vue